/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ granted: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Tool_Grants_CountInputs */



/**
* | output |
* | --- |
* | "{granted} of {total} tools" |
*
* @param {Spaces_Tool_Grants_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_count = /** @type {((inputs: Spaces_Tool_Grants_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.granted} von ${i?.total} Tools`)
	return /** @type {LocalizedString} */ (`${i?.granted} of ${i?.total} tools`)
});